var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-simple-table', {
    staticClass: "v-data-table--no-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("구분")]), _c('th', [_vm._v("성함")]), _c('th', [_vm._v("세부내용")])])]), _c('tbody', [_vm._l(_vm.supporters, function (supporter) {
    return _vm._l(supporter.list, function (item, index) {
      return _c('tr', {
        key: index
      }, [index === 0 ? _c('th', {
        attrs: {
          "rowspan": supporter.list.length
        }
      }, [_vm._v(_vm._s(supporter.position))]) : _vm._e(), _c('td', [_vm._v(_vm._s(item.name))]), _c('td', _vm._l(item.detail, function (text) {
        return _c('div', {
          key: text
        }, [_vm._v(_vm._s(text))]);
      }), 0)]);
    });
  })], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }